import { getAssetPath } from 'lib/utils/common/commonUtils'

export const ASSET_PREFIX = `${getAssetPath()}/static/img/pages/about-us`

export const ASSETS = {
  HERO_IMAGE: `${ASSET_PREFIX}/hero2025.jpg`,
  DOWN_ARROW: `${ASSET_PREFIX}/down-arrow.svg`,
  PURPOSE_BG: `${ASSET_PREFIX}/purpose-bg2025.jpg`,
  POMELO_BRAND_BG: `${ASSET_PREFIX}/brand-bg2025.jpg`,
  POMELO_BRAND_LOGO: `${ASSET_PREFIX}/brands/pomelo.svg`,
  BRANDS: [
    {
      path: `${ASSET_PREFIX}/brands/maybelline.svg`,
      ratio: 43 / 156,
    },
    {
      path: `${ASSET_PREFIX}/brands/urban-revivo.svg`,
      ratio: 43 / 156,
    },
    {
      path: `${ASSET_PREFIX}/brands/havaianas.svg`,
      ratio: 43 / 70,
    },
    {
      path: `${ASSET_PREFIX}/brands/tommy-hilfiger.svg`,
      ratio: 43 / 240,
    },
    {
      path: `${ASSET_PREFIX}/brands/rally.svg`,
      ratio: 43 / 70,
    },
    {
      path: `${ASSET_PREFIX}/brands/levis.svg`,
      ratio: 43 / 70,
    },
    {
      path: `${ASSET_PREFIX}/brands/calvinklein.svg`,
      ratio: 43 / 156,
    },
    {
      path: `${ASSET_PREFIX}/brands/loccitane.svg`,
      ratio: 43 / 117,
    },
    {
      path: `${ASSET_PREFIX}/brands/mitr.svg`,
      ratio: 43 / 66,
    },
    {
      path: `${ASSET_PREFIX}/brands/birkenstock.svg`,
      ratio: 43 / 113,
    },
    {
      path: `${ASSET_PREFIX}/brands/converse.svg`,
      ratio: 43 / 156,
    },
    {
      path: `${ASSET_PREFIX}/brands/jungsaemmool.svg`,
      ratio: 43 / 156,
    },
    {
      path: `${ASSET_PREFIX}/brands/vans.svg`,
      ratio: 43 / 70,
    },
    {
      path: `${ASSET_PREFIX}/brands/sulwhasoo.svg`,
      ratio: 43 / 156,
    },
    {
      path: `${ASSET_PREFIX}/brands/puma.svg`,
      ratio: 43 / 70,
    },
    {
      path: `${ASSET_PREFIX}/brands/yvis.svg`,
      ratio: 43 / 113,
    },
    {
      path: `${ASSET_PREFIX}/brands/aland.svg`,
      ratio: 43 / 121,
    },
  ],
  TTB_HERO: `${ASSET_PREFIX}/ttb-bg2025.jpg`,
  DOWN_TO_EARTH_BG: `${ASSET_PREFIX}/down-to-earth-bg.png`,
  POMELO_GIRLS: [
    `${ASSET_PREFIX}/pomelo-girls-1-2025.jpg`,
    `${ASSET_PREFIX}/pomelo-girls-2-2025.jpg`,
    `${ASSET_PREFIX}/pomelo-girls-3-2025.jpg`,
    `${ASSET_PREFIX}/pomelo-girls-4-2025.jpg`,
    `${ASSET_PREFIX}/pomelo-girls-5-2025.jpg`,
    `${ASSET_PREFIX}/pomelo-girls-6-2025.jpg`,
  ],
  PACKAGE: `${ASSET_PREFIX}/package.png`,
}

export const CONTENTS = {
  ABOUT_TITLE: {
    key: 'ABOUT_US_PAGE.ABOUT_US_TITLE',
    value: 'เกี่ยวกับเรา',
  },
  ABOUT_CONTENT_1: {
    key: 'ABOUT_US_PAGE.ABOUT_CONTENT_1',
    value:
      'เปิดตัวในปี พ.ศ. 2556 Pomelo ที่สุดของแพลตฟอร์มแฟชั่นชั้นนำแห่งเอเชียตะวันออกเฉียงใต้ ครบครันด้วยไอเท็มมาใหม่ทุกสัปดาห์จากกว่าหลายร้อยแบรนด์ จากดีไซเนอร์แบรนด์ในประเทศ แบรนด์ยอดนิยมจาก IG และแบรนด์ชื่อดัง ระดับโลกที่พลาดไม่ได้ เพราะเราเชื่อว่าแฟชั่นเป็นเรื่องของทุกคน',
  },
  ABOUT_CONTENT_2: {
    key: 'ABOUT_US_PAGE.ABOUT_CONTENT_2',
    value:
      'เราจึงพยายามพัฒนาอยู่เสมอเพื่อสร้างประสบการณ์การช้อปที่ดีที่สุดให้แก่คุณด้วยเสื้อผ้าหลากสไตล์หลายแบรนด์ บริการลองก่อนจ่ายที่ขึ้นชื่ออย่าง Tap.Try.Buy. และความใส่ใจสุดพิเศษผ่าน Pomelo Perks* เราค้นหาวิธีการต่าง ๆ ที่ช่วยอัปเดตสไตล์ของคุณให้สดใหม่เสมอแบบสะดวกสบายและสนุกสนานไปพร้อมกัน',
  },
  PURPOSE_TITLE: {
    key: 'ABOUT_US_PAGE.PURPOSE_TITLE',
    value: 'เราตั้งใจ เพื่อให้คุณ สนุกได้เต็มที่กับการแต่งตัว',
  },
  PURPOSE_CONTENT: {
    key: 'ABOUT_US_PAGE.PURPOSE_CONTENT',
    value:
      'ทุกครั้งที่ช้อป ไม่ว่าจะเป็นสไตล์ไหน รูปร่างอย่างไร โอกาสใด หรือมีงบแค่ไหน เราจะทำให้มั่นใจว่าคุณได้สัมผัสบางอย่าง ที่จะทำให้ทุกช่วงเวลาในชีวิตของคุณเป็นช่วงเวลาที่พิเศษ เพราะคุณคือคนพิเศษสำหรับเราเสมอ',
  },
  PURPOSE_SHOP_NOW: {
    key: 'SHOP NOW',
    value: 'Shop now',
  },
  POMELO_BRAND_TITLE: {
    key: 'ABOUT_US_PAGE.POMELO_BRAND_TITLE',
    value: 'แบรนด์ Pomelo',
  },
  POMELO_BRAND_CONTENT_1: {
    key: 'ABOUT_US_PAGE.POMELO_BRAND_CONTENT_1',
    value:
      'ด้วยราคาที่เข้าถึงได้  ใส่ใจต่อสิ่งแวดล้อม และสไตล์ที่นำเทรนด์เสื้อผ้าของเราช่วยสร้างความมั่นใจ ทำให้รู้สึกดีจากภายใน และยังส่งผลให้ภายนอกก็ดูดีได้อีก',
  },
  POMELO_BRAND_CONTENT_2: {
    key: 'ABOUT_US_PAGE.POMELO_BRAND_CONTENT_2',
    value:
      'ไม่ว่าจะต้องเผชิญกับความท้าทายใด ๆ ในชีวิตก็พร้อมเสมอ จะสายเที่ยวคาเฟ่ เท่สุด ๆ ที่ปาร์ตี้ ลุคเบสิกที่มั่นใจ ไม่ว่าจะสไตล์ไหน ๆ ก็สามารถเจอกับไอเท็มที่ถูกใจ และเข้ากับไลฟ์สไตล์ของคุณ',
  },
  POMELO_BRAND_CONTENT_3: {
    key: 'ABOUT_US_PAGE.POMELO_BRAND_CONTENT_3',
    value:
      'เพราะเราใส่ใจกับทุกดีไซน์ และสร้างสรรค์ด้วยใจ เพื่อสาว ๆ เอเชียตะวันออกเฉียงใต้โดยเฉพาะ',
  },
  BRANDS_TITLE: {
    key: 'ABOUT_US_PAGE.BRANDS_TITLE',
    value: 'แบรนด์โปรดของคุณ บน Pomelo',
  },
  BRANDS_CONTENT_1: {
    key: 'ABOUT_US_PAGE.BRANDS_CONTENT_1',
    value:
      'จากดีไซเนอร์แบรนด์ในประเทศ แบรนด์ใน IG ไปจนถึงแบรนด์ชื่อดังระดับโลกที่พลาดไม่ได้ เรามีแบรนด์พาร์ทเนอร์ที่กว้างขวางเพื่อให้ตอบโจทย์และตรงใจคุณที่สุด  สามารถเลือกสไตล์ที่เป็นตัวเองได้อย่างอิสระและเต็มที่ อีกทั้งยังเพิ่มความมั่นใจผ่านไอเท็มใหม่ ๆ ที่รอให้ค้นหาอีกด้วย',
  },
  BRANDS_CONTENT_2: {
    key: 'ABOUT_US_PAGE.BRANDS_CONTENT_2',
    value:
      'เหล่าสาว ๆ #PomeloGirls (คุณไง!) เป็นคนสำคัญสำหรับเรา เป็นคนที่เราต้องการนำเสนอสไตล์ที่ตรงใจที่สุด  ไม่ว่าจะเป็นไซส์ เนื้อผ้า  & ไวบ์ของเสื้อผ้าจาก Pomelo แบรนด์ต่าง ๆ ทั้งในประเทศ และแบรนด์ระดับโลกอีกเพียบที่เราคัดสรรค์มาให้ ทุกอย่างถูกออกแบบ รังสรรค์ และทำด้วยใจเพื่อสาว ๆ ในชุมชนเอเชียตะวันออกเฉียงใต้',
  },
  BRANDS_AND_MORE: {
    key: 'ABOUT_US_PAGE.BRANDS_AND_MORE',
    value: '& อีกเพียบ',
  },
  TTB_TITLE: {
    key: 'ABOUT_US_PAGE.TTB_TITLE',
    value: 'เคยได้ยินเกี่ยวกับ Tap.Try.Buy. มั้ย?',
  },
  TTB_TAP_CONTENT: {
    key: 'ABOUT_US_PAGE.TTB_TAP_CONTENT',
    value: 'คลิกเลือกจากหลายพันสไตล์และแบรนด์บนแอปฯ',
  },
  TTB_TRY_CONTENT: {
    key: 'ABOUT_US_PAGE.TTB_TRY_CONTENT',
    value: 'ลองในจุดบริการที่สะดวกฟรี',
  },
  TTB_BUY_CONTENT: {
    key: 'ABOUT_US_PAGE.TTB_BUY_CONTENT',
    value: 'จ่ายเฉพาะชิ้นที่ถูกใจ',
  },
  TTB_CONTENT: {
    key: 'ABOUT_US_PAGE.TTB_CONTENT',
    value:
      'บริการลองก่อนจ่าย หรือ Tap.Try.Buy. สร้างประสบการณ์การช้อปสุดพิเศษเฉพาะที่ Pomelo เท่านั้น เพื่อใส่ใจลูกค้าคนสำคัญอย่างคุณ เลือกช้อปกว่าหลายพันสไตล์และแบรนด์แบบออนไลน์ ลองไอเท็มในจุดบริการที่สะดวก หรือที่บ้านของคุณเองได้แบบฟรี ๆ จ่ายแค่ชิ้นที่ถูกใจ หมดกังวลเรื่องการคืนสินค้าไปได้เลย',
  },
  TTB_CTA: {
    key: 'ABOUT_US_PAGE.TTB_CTA',
    value: 'TRY NOW FOR FREE',
  },
  DOWN_TO_EARTH_TITLE: {
    key: 'ABOUT_US_PAGE.DOWN_TO_EARTH_TITLE',
    value: 'Down to Earth',
  },
  DOWN_TO_EARTH_SUBTITLE_1: {
    key: 'ABOUT_US_PAGE.DOWN_TO_EARTH_SUBTITLE_1',
    value: 'อ่อนโยน และใส่ใจสิ่งแวดล้อม',
  },
  DOWN_TO_EARTH_SUBTITLE_2: {
    key: 'ABOUT_US_PAGE.DOWN_TO_EARTH_SUBTITLE_2',
    value:
      'นำเสนอสไตล์ใหม่ ๆ และเทรนด์ล่าสุดมาให้คุณเป็นหน้าที่ที่สำคัญของเรา แต่การใส่ใจสิ่งแวดล้อมก็สำคัญเช่นกัน',
  },
  DOWN_TO_EARTH_CONTENT: {
    key: 'ABOUT_US_PAGE.DOWN_TO_EARTH_CONTENT',
    value:
      'เรามองหาแนวทางใหม่ ๆ ที่จะทำให้วงการแฟชั่นที่เป็นมิตรต่อโลกก้าวหน้าไปเรื่อย ๆ เพื่อสร้างอนาคตที่ยั่งยืนสำหรับเราทุกคน เรามุ่งมั่นที่จะสร้างการเปลี่ยนแปลงเชิงบวกผ่านแพลตฟอร์มของเรา และมอบตัวเลือกของแฟชั่น ทันสมัยที่ใส่ใจสิ่งแวดล้อมในราคาที่จับต้องได้',
  },
  POMELO_GIRLS_CONTENT: {
    key: 'ABOUT_US_PAGE.POMELO_GIRLS_CONTENT',
    value:
      'เสื้อผ้าจากดีไซน์สตูดิโอในกรุงเทพฯ ได้ส่งถึงหน้าบ้านกว่าหลายล้านหลังคาเรือนทั่วโลกแล้วคุณล่ะรออะไรอยู่? มาเป็นส่วนหนึ่งกับสาว ๆ #PomeloGirls กันเถอะ!',
  },
}

export default {
  ASSETS,
  CONTENTS,
}
